import React, {useRef, useEffect}    from 'react';
import Vimeo                            from '@vimeo/player'
import Audio                            from './new-player/audio';
import {updateVideoStatus}              from '../actions/movie';
import {VIDEO_PLAYING, VIDEO_PAUSED}    from '../constants';

const VimeoPlayer = (props) => {
    const playerRef = useRef(null);
    const iframeRef = useRef(null);


    const audioCallback = (state) => {
        if (playerRef.current && state.state === 'LIVEPLAY') {
            playerRef.current.pause();
            Audio.removeCallback(audioCallback);
        }
    }

    const onPlay = () => {
        Audio.pause();
        props.onPlay && props.onPlay();
        Audio.addCallback(audioCallback);
        updateVideoStatus(props.videoId, VIDEO_PLAYING);
    }
    const onPause = () => {
        props.onPause && props.onPause();
        updateVideoStatus(props.videoId, VIDEO_PAUSED);
    }
    const playPause = async () => {
        if (!playerRef.current) {
            console.warn('Player not ready');
            return;
        }
        
        try {
            const isPaused = await playerRef.current.getPaused();
            if (isPaused) {
                await playerRef.current.play();
            } else {
                await playerRef.current.pause();
            }
        } catch (error) {
            console.error('Error controlling playback:', error);
        }
    }
    const onKeyPress = (e) => {
        if (e.keyCode === 32) {
            e.preventDefault();
            playPause();
        }
    }
    const onLoaded = (player, iframe) => {
        console.log('Vimeo player loaded successfully');
        playerRef.current = player;
        
        if (props.focus || props.autoPlay) {
            if (iframe) {
                iframe.allow = "autoplay; fullscreen; picture-in-picture";
            }
            
            if (props.focus) {
                iframe?.focus();
                document.addEventListener('keypress', onKeyPress);
            }
            
            if (props.autoPlay) {
                setTimeout(async () => {
                    try {
                        if (playerRef.current) {
                            await playerRef.current.play();
                            console.log('Autoplay started successfully');
                        }
                    } catch (error) {
                        console.warn('Autoplay failed:', error);
                    }
                }, 500);
            }
        }
        
        updateVideoStatus(props.videoId, VIDEO_PAUSED);
    }

    const isPlaying = async () => {
        if (!playerRef.current) return false;
        try {
            return !(await playerRef.current.getPaused());
        } catch (error) {
            console.warn('Error checking player state:', error);
            return false;
        }
    }

    // componentDidMount
    useEffect(() => {
        const {onEnded} = props;
        let player = null;

        const initializePlayer = () => {
            if (!iframeRef.current) {
                console.warn('Iframe not available for Vimeo player');
                return;
            }

            try {
                player = new Vimeo(iframeRef.current, {
                    id: props.videoId,
                    width: props.width,
                    height: props.height,
                    autoplay: props.autoPlay || false,
                    controls: !props.hideControls,
                    dnt: true
                });

                player.on('loaded', () => onLoaded(player, iframeRef.current));
                player.on('play', onPlay);
                player.on('pause', onPause);
                if (onEnded) {
                    player.on('ended', onEnded);
                }

                player.on('error', (error) => {
                    console.error('Vimeo player error:', error);
                });
            } catch (error) {
                console.error('Error initializing Vimeo player:', error);
            }
        };

        const timer = setTimeout(initializePlayer, 100);

        return () => {
            clearTimeout(timer);
            if (player) {
                try {
                    player.unload();
                } catch (error) {
                    console.warn('Error unloading player:', error);
                }
            }
            document.removeEventListener('keypress', onKeyPress);
        };
    }, [props.videoId])

    const src = `https://player.vimeo.com/video/${props.videoId}?autoplay=${props.autoPlay?1:0}&controls=${props.hideControls?0:1}&quality=auto`;
    const { supportFS, width, height} = props
    return (
        <iframe 
            src={src} 
            ref={iframeRef} 
            allowFullScreen={supportFS} 
            width={width} 
            height={height} 
            frameBorder='0'
            allow="autoplay; fullscreen; picture-in-picture"
            title={`Vimeo video ${props.videoId}`}
        />
    );
}


VimeoPlayer.defaultProps = {
    width: '100%',
    height: '100%',
    supportFS: true,
}


export default VimeoPlayer;